/** Allowed menu text font values — keep in sync with backend MenuV2 schema and front client Menu. */
export const MENU_TEXT_FONTS = [
  "roboto",
  "inter",
  "poppins",
  "montserrat",
  "lato",
  "nunito",
  "openSans",
  "playfair",
  "merriweather",
  "oswald",
  "raleway",
  "ubuntu",
  "rubik",
  "sourceSansPro",
  "workSans",
  "bitter",
  "aachen",
  "americanType",
  "avantGarde",
  "arial",
  "arialBlack",
  "bankGothic",
  "bauhaus",
  "bostonTraffic",
  "brody",
  "brushScript",
  "centurySchoolbook",
  "comicSans",
  "cooper",
  "cooperplate",
  "courierNew",
  "edwardianScript",
  "futura",
  "garamond",
  "helvetica",
  "impact",
  "myriadPro",
  "murrayHill",
  "oldEnglish",
  "papyrus",
  "plaza",
  "serpentine",
  "systems",
  "stencil",
  "topSecret",
  "trajan",
  "timesNewRoman",
  "timesBold",
  "unitedStates",
  "yearbook",
];

export function normalizeMenuTextFont(value) {
  return MENU_TEXT_FONTS.includes(value) ? value : "roboto";
}
